const baseStyle = {
    fontSize: '1em',
}

export default {
    baseStyle,
}
